module.exports = fox._r("images/promo/tutorial/13.png", __webpack_public_path__ + "_/common/images/promo/tutorial/13.png");


//////////////////
// WEBPACK FOOTER
// ../common/images/promo/tutorial/13.png
// module id = 661
// module chunks = 2